import { File as SharedFile, type FileModel, type FileProps as SharedFileProps } from '@dec/shared';
import { notificationError, notificationSuccess } from 'app/core/toast';
import { saveAs } from 'file-saver';
import i18next from 'i18next';

import { label as lblCommon } from '../../../modules/translation';

import { downloadFile, uploadFile } from './file.sevice';

type Props = Omit<
  SharedFileProps,
  'texts' | 'uploadFile' | 'downloadFile' | 'onUploadSuccess' | 'onUploadError'
>;

function File(props: Props) {
  return (
    <SharedFile
      {...props}
      texts={{
        download: lblCommon('fileDownload'),
        search: lblCommon('fileSearch'),
        noFileSelected: lblCommon('noFileSelected'),
        fileUploadMaxSize: i18next.t('common.messages.fileUploadMaxSize'),
        fileRequirements: props.accept?.includes('pdf') ? lblCommon('fileRequirements') : undefined,
        uploading: lblCommon('fileUploading'),
        uploaded: lblCommon('fileUploaded'),
        uploadError: lblCommon('fileUploadError'),
        selectFile: lblCommon('fileSelect'),
        replaceFile: lblCommon('fileReplace'),
        removeFile: lblCommon('fileRemove'),
        removing: lblCommon('fileRemoving'),
        removeError: lblCommon('fileRemoveError')
      }}
      uploadFile={async (file, name) => {
        const formData = new FormData();
        formData.append('file', file);
        const fileId = await uploadFile(formData, name);
        const value: FileModel = { id: fileId as string, name };

        notificationSuccess(i18next.t('common.messages.fileUpload'));

        return {
          fieldValue: value,
          fileModel: value
        };
      }}
      downloadFile={async (fileId) => {
        const response: any = await downloadFile(fileId);
        const blob = await fetch('data:application/octet-stream;base64,' + response.content).then(
          (res) => res.blob()
        );

        saveAs(blob, response.name);
      }}
      onUploadError={(message) => notificationError(message)}
      hideErrorAfterSuccess={true}
    />
  );
}

export default File;
